import React from 'react'
import ShowCategories from '../ui/ShowCategories'
import CategoryAreas from '../ui/CategoryAreas'
import moment from 'moment'
import FileImg from '../../images/icons/FileIcon'
import editImage from '../../images/icons/edit_black.svg';
import arrowRight from '../therapist/images/arrow-right.svg'
import folderSVG from '../therapist/images/folder-solid.svg'
import arrowRightDark from '../therapist/images/arrow-right-dark.svg'
import ThumbUpImg from '../../images/icons/thumb_up_black.svg'

const ShowAssessment = (props) => {
  const {
    therapy_categories,
    therapy_areas,
    assessmentCategoryClick,
    active_category,
    toggleShowMore,
    toggled,
    click,
    index
  } = props;

  let assessment = props.assessment.data

  const categoryAreas = () => assessment.therapy_areas
    .filter(areaId => therapy_areas[areaId] ? therapy_areas[areaId].categories.indexOf(active_category) !== -1 : false)
    .map(areaId => therapy_areas[areaId])

  const age = () => {
    if (props.patient.dob) {
      let duration = moment.duration(moment(props.assessment.created).diff(props.patient.dob))
      return duration.years() + ' years ' + duration.months() + ' months'
    } else {
      return ''
    }
  }

  return assessment ? <div key={index} className="">
    {/* ASSESMENT CARD */}
      <div className="assessment-content paper">
      <div>
          <ul className="md-list card assesmentCard marginless">
            <li className="card-header row marginTopNone">
              <div className="patientSessionOrAssesmentIcon">
                <span>A</span>
              </div>
              <div className="headerInfo">
                <p>{moment(assessment.doa).format('ddd Do of MMM YYYY')}</p>
                <small>Therapist: {assessment.therapist.name} | Patient Age: { age() } years</small>
              </div>
              <div className="headerAction">
                <a onClick={() => { click(assessment) }}  className="link padding textWhite" >OPEN</a>
              </div>
            </li>
            
            <li className="internalNotes">
              {/*<h5>Parent Notes:</h5>*/}
              <div className={ toggled === assessment._id? 'notesContainer show' : 'notesContainer' }>
                {assessment.description}
              </div>
              {
                assessment.description &&
                <div className="readMoreContainer">
                  <a onClick={() => {toggleShowMore(assessment._id)} }> {toggled === assessment._id ? 'Read Less': 'Read More'}</a>          
                </div>
              }
            </li>

            <li className="categoriesSection">
              <div className="catogories">
                <ShowCategories
                therapy_areas={assessment.therapy_areas.map(areaId => therapy_areas[areaId])}
                therapy_categories={therapy_categories}
                />
              </div>
              <div className="commentAndDocs">
                {/*<div className="documents">
                  {assessment.documents.length ? assessment.documents.map(doc => {
                    return <p key={`doc-${doc.name}`}>
                      <FileImg /><a href={`${doc.url}`} target="_new">{doc.name}</a>
                    </p>
                  }) : null}
                </div>*/}
                <div className="documents">
                  <img src={folderSVG} />
                  <p>{assessment.documents.length } Documents</p>
                </div>
              </div>
            </li>
          </ul>
          <div className="hrAssesment">
            <span></span>
          </div>
        </div>
    </div>
        {/* ASSESMENT CARD END */}
   {/* <div className="">
      {showAssessment && <div className="assessment-content paper">
        <p><b>Latest Assessment</b></p>
        <table className="data" >
          <tr>
            <th width="30%">Date</th>
            <td>{moment(assessment.modified).format('ddd Do of MMM YYYY')}</td>
          </tr>
          <tr>
            <th width="30%">Age</th>
            <td>{age()}</td>
          </tr>
        </table>
        <div>
          <br />
          <div className="md-body1">Description</div>
          <p>{assessment.description}</p>
          <br />
        </div>
        <div >
          <div className="md-body1">Therapy areas</div>
          <ShowCategories
            active_category={active_category}
            click={assessmentCategoryClick}
            therapy_areas={assessment.therapy_areas.map(areaId => therapy_areas[areaId])}
            therapy_categories={therapy_categories}
          />
          <CategoryAreas active_category={active_category} therapy_areas={categoryAreas()} />
        </div>
        <div>
          {assessment.documents.length ? assessment.documents.map(doc => {
            return <p key={`doc-${doc.name}`}>
              <FileImg /><a href={`${doc.url}`} target="_new">{doc.name}</a>
            </p>
          }) : null}
        </div>
        <br />
        <hr />
      </div>
      }
    </div>
*/}
  </div>
    : <p>No assessment</p>
}


ShowAssessment.defaultProps = {
  assessment: {},
  patient: {}
}

export default ShowAssessment;



// WEBPACK FOOTER //
// ./src/components/parent/ShowAssessment.jsx